
// Header scroll effect
const header = document.getElementById('header');
let lastScroll = 0;
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

// Language switcher
var langSwitcher = document.getElementById('langSwitcher');
function toggleLang() {
  if (langSwitcher) langSwitcher.classList.toggle('open');
}
if (langSwitcher) {
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#langSwitcher')) {
      langSwitcher.classList.remove('open');
    }
  });
}

// Mobile nav
function toggleMobile() {
  document.getElementById('mobileNav').classList.toggle('open');
  document.body.style.overflow = document.getElementById('mobileNav').classList.contains('open') ? 'hidden' : '';
}

// Intersection Observer for reveal animations
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    const target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 80;
      window.scrollTo({
        top: target.offsetTop - offset,
        behavior: 'smooth'
      });
    }
  });
});

// Workflow step toggle
function toggleStep(headerEl) {
  const step = headerEl.closest('.wf-step');
  step.classList.toggle('open');
}

// Integrace toggle
function toggleIntegrace(btn) {
  const grid = btn.parentElement.previousElementSibling;
  const expanding = !grid.classList.contains('integrace__grid--expanded');
  grid.classList.toggle('integrace__grid--expanded');
  btn.textContent = expanding ? 'Zobrazit méně' : 'Zobrazit více';
  if (!expanding) {
    const section = grid.closest('.integrace');
    const headerH = document.getElementById('header').offsetHeight;
    const sectionTop = section.getBoundingClientRect().top + window.scrollY - headerH - 16;
    if (window.scrollY > sectionTop) {
      window.scrollTo({ top: sectionTop, behavior: 'smooth' });
    }
  }
}


// ==================== LIGHTBOX ====================
var lbImages = [];
var lbCaptions = [];
var lbIndex = 0;
var lbSelector = [
  '.article__gallery-item img',
  '.article__content > img',
  '.article__cover',
  '.article__img-float',
  '.prod-section__visual img',
  '.wl-showcase__item img',
  '.phone-gallery__item img',
  '.terminal-gallery img',
  '.rozvoz-gallery img',
  '.web-showcase__img img'
].join(', ');

document.querySelectorAll(lbSelector).forEach(function(img) {
  var idx = lbImages.length;
  lbImages.push(img.currentSrc || img.src);
  // caption: prefer adjacent .article__gallery-caption / .article__caption / wl-showcase__label, fallback to alt
  var caption = '';
  var next = img.nextElementSibling;
  if (next && (next.classList.contains('article__gallery-caption') || next.classList.contains('article__caption') || next.classList.contains('wl-showcase__label'))) {
    caption = next.textContent.trim();
  } else if (img.parentElement) {
    var sibling = img.parentElement.querySelector('.article__gallery-caption, .article__caption, .wl-showcase__label, .web-showcase__title');
    if (sibling) caption = sibling.textContent.trim();
  }
  if (!caption) caption = img.alt || '';
  lbCaptions.push(caption);
  img.style.cursor = 'zoom-in';
  img.addEventListener('click', function(e) {
    e.preventDefault();
    lbIndex = idx;
    lbShow();
  });
});

function lbShow() {
  var lb = document.getElementById('lightbox');
  if (!lb) return;
  document.getElementById('lightboxImg').src = lbImages[lbIndex];
  document.getElementById('lightboxCaption').textContent = lbCaptions[lbIndex];
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function lbNav(dir, e) {
  if (e) e.stopPropagation();
  else if (typeof event !== 'undefined' && event) event.stopPropagation();
  if (lbImages.length === 0) return;
  lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length;
  lbShow();
}
function closeLightbox(e) {
  if (e && e.target !== e.currentTarget && e.target.id !== 'lightboxImg') return;
  var lb = document.getElementById('lightbox');
  if (!lb) return;
  lb.classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e) {
  var lb = document.getElementById('lightbox');
  if (!lb || !lb.classList.contains('open')) return;
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowRight') lbNav(1);
  if (e.key === 'ArrowLeft') lbNav(-1);
});

// Lazy-load reCAPTCHA when contact section enters viewport
(function() {
  var RECAPTCHA_KEY = '6Lcwa1gfAAAAAOy4kQrA93K6nJKkbfcQt306b-kn';
  var contactSection = document.getElementById('kontakt');
  if (contactSection) {
    var recaptchaLoaded = false;
    var recaptchaObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !recaptchaLoaded) {
        recaptchaLoaded = true;
        var s = document.createElement('script');
        s.src = 'https://www.google.com/recaptcha/api.js?render=' + RECAPTCHA_KEY;
        s.async = true;
        s.defer = true;
        document.head.appendChild(s);
        recaptchaObserver.disconnect();
      }
    }, { rootMargin: '200px' });
    recaptchaObserver.observe(contactSection);
  }

  // reCAPTCHA token při odeslání kontaktního formuláře
  var contactForm = document.getElementById('contactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      if (contactForm.dataset.recaptchaDone) return;
      e.preventDefault();

      // GA4: konverze — odeslání kontaktního formuláře
      if (typeof gtag === 'function') {
        gtag('event', 'generate_lead', {
          event_category: 'contact',
          event_label: 'contact_form'
        });
      }

      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
          grecaptcha.execute(RECAPTCHA_KEY, {action: 'contact'}).then(function(token) {
            var tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'token';
            tokenInput.value = token;
            contactForm.appendChild(tokenInput);
            var actionInput = document.createElement('input');
            actionInput.type = 'hidden';
            actionInput.name = 'action';
            actionInput.value = 'contact';
            contactForm.appendChild(actionInput);
            contactForm.dataset.recaptchaDone = '1';
            contactForm.submit();
          }).catch(function() {
            contactForm.dataset.recaptchaDone = '1';
            contactForm.submit();
          });
        });
      } else {
        contactForm.submit();
      }
    });
  }
})();

// ==================== GA4 CONVERSION TRACKING ====================
(function() {
  if (typeof gtag !== 'function') return;

  // Konverze 2: Klik na registraci (30 dní zdarma)
  document.querySelectorAll('a[href="/registrace"]').forEach(function(link) {
    link.addEventListener('click', function() {
      gtag('event', 'sign_up', {
        event_category: 'registration',
        event_label: link.closest('[class]') ? link.closest('section,footer')?.className || 'unknown' : 'unknown'
      });
    });
  });

  // Konverze 3: Klik na telefon
  document.querySelectorAll('a[href^="tel:"]').forEach(function(link) {
    link.addEventListener('click', function() {
      gtag('event', 'phone_click', {
        event_category: 'contact',
        phone_number: link.href.replace('tel:', '')
      });
    });
  });
})();


